<template>
    <v-container>
      <!-- Header Section -->
      <v-row justify="space-between" align="center">
        <h2>Arrange Photo</h2>
        <div>
          <v-btn icon @click="showHelp">
            <v-icon>mdi-help-circle</v-icon>
          </v-btn>
          <v-btn color="primary" dark @click="saveChanges">
            Save
          </v-btn>
        </div>
      </v-row>
  
      <v-divider class="my-4"></v-divider>
  
      <!-- Images Section -->
      <v-row>
        <v-col
          v-for="(image, index) in arrangedImages"
          :key="index"
          cols="12"
          sm="6"
          md="4"
        >
          <v-card>
            <v-img :src="image.url" :alt="image.name" height="200px"></v-img>
            <v-card-text class="text-center">
              <p>{{ image.name }}</p>
              <p>Image {{ index + 1 }}</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
  
      <v-divider class="my-4"></v-divider>
  
      <!-- Backup Images Section -->
      <h3>Backup Images</h3>
      <v-row>
        <v-col
          v-for="(image, index) in backupImages"
          :key="index"
          cols="12"
          sm="6"
          md="4"
        >
          <v-card>
            <v-img :src="image.url" :alt="image.name" height="200px"></v-img>
            <v-card-text class="text-center">
              <p>{{ image.name }}</p>
            </v-card-text>
            <v-card-actions>
              <v-btn color="red" text @click="deleteBackupImage(index)">
                Delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  <script setup>
  import { ref } from 'vue';
  
  // Sample Data for Images
  const arrangedImages = ref([
    { url: 'https://via.placeholder.com/150', name: 'Alice' },
    { url: 'https://via.placeholder.com/150', name: 'Bob' },
    { url: 'https://via.placeholder.com/150', name: 'Charlie' },
  ]);
  
  const backupImages = ref([
    { url: 'https://via.placeholder.com/150', name: 'Backup 1' },
    { url: 'https://via.placeholder.com/150', name: 'Backup 2' },
  ]);
  
  // Methods
  const saveChanges = () => {
    alert('Changes saved successfully!');
    backupImages.value = []; // Clear backup images after saving
  };
  
  const deleteBackupImage = (index) => {
    backupImages.value.splice(index, 1);
  };
  
  const showHelp = () => {
    alert('Help: You can arrange photos by editing them here. Save changes to finalize.');
  };
  </script>
<style scoped>
.v-card {
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
}

.v-card:hover {
  transform: scale(1.05);
}
</style>
  